import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import 'scss/5_components/_popover.scss'

export class PopoverLink extends PureComponent {
  render() {
    const {
      align,
      anchorParams,
      anchorText,
      children,
      className,
      mouseEnterEvent,
      mouseLeaveEvent,
    } = this.props
    const popoverClasses = ['popover', className]
    if (align) popoverClasses.push(`align-${align}`)
    const popoverClass = popoverClasses.join(' ')
    return (
      <>
        <span className='popover-anchor mr1'>
          <a onMouseEnter={mouseEnterEvent} onMouseLeave={mouseLeaveEvent} {...anchorParams}>
            {anchorText}
          </a>
          <div className={popoverClass}>{children}</div>
        </span>
      </>
    )
  }
}

export default PopoverLink

PopoverLink.propTypes = {
  mouseEnterEvent: PropTypes.func.isRequired,
  mouseLeaveEvent: PropTypes.func.isRequired,
  anchorText: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  anchorParams: PropTypes.shape({}),
  align: PropTypes.string,
  children: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
}

PopoverLink.defaultProps = {
  align: null,
  anchorText: '',
  className: '',
  anchorParams: {},
}
